// ---------------------------------------------------------------------------
// Dono dos portais de uma tela guardada (BUG-331, 06/10/2026).
//
// O `<Activity mode="hidden">` esconde a árvore da tela guardada, mas NÃO o
// que ela desenhou por portal: uma folha aberta que leva a outra tela ficaria
// pintada por cima dela (medido em harness: portal visível 8/8 com a tela
// escondida). E avisar a tela escondida não adianta — o React adia as
// atualizações de uma árvore oculta, ela nunca "ouve" que saiu de cena.
//
// Por isso a decisão é de DOM, não de render: todo portal de tela leva a marca
// do dono (o pathname da instância, FIXO por instância — não precisa de
// re-render para estar certo) e uma regra CSS, reescrita no commit de cada
// navegação, esconde toda marca que não é a da tela visível. Portal fora de
// uma tela guardada (Foco, chuva de moedas) não tem dono e nunca some.
// O portal com a marca: `ownedPortal` (`lib/navigation/ownedPortal.ts`).
// ---------------------------------------------------------------------------

import { createContext, useContext } from "react";

/** Pathname da tela guardada que contém o componente; `null` fora delas. */
export const PageOwnerContext = createContext<string | null>(null);

export const PAGE_OWNER_ATTR = "data-page-owner";
const STYLE_ID = "kept-page-portals";

export function usePageOwner(): string | null {
  return useContext(PageOwnerContext);
}

/** Esconde os portais de todo dono que não é `active`. Idempotente. */
export function showOnlyPageOwner(active: string, doc: Document = document): void {
  let el = doc.getElementById(STYLE_ID);
  if (!el) {
    el = doc.createElement("style");
    el.id = STYLE_ID;
    doc.head.appendChild(el);
  }
  el.textContent = `[${PAGE_OWNER_ATTR}]:not([${PAGE_OWNER_ATTR}=${JSON.stringify(active)}]){display:none!important}`;
}

/** Tira a regra (o frame saiu de cena: não há tela visível para comparar). */
export function clearPageOwnerStyle(doc: Document = document): void {
  doc.getElementById(STYLE_ID)?.remove();
}
